// Logged-in app page: clip collections (routes/ClipPacks.tsx). Keep keys in sync with
// en/appCollections.ts. Słownik LOCKED — „paczka klipów / paczki” w każdym zdaniu.
//
// Sesja 33: szyna kolekcji nie nosi liczników, a „Nieprzypisane” nie jest filtrem —
// „Bez kolekcji” żyje wyłącznie w oknie „Przenieś do kolekcji” jako wartość wyboru.
export const appCollections = {
  head: {
    title: 'Kolekcje',
  },
  filter: {
    all: 'Wszystkie',
    edimi: 'EDIMI',
  },
  create: {
    cta: 'Nowa kolekcja',
    heading: 'Nowa kolekcja',
    name: 'Nazwa',
    submit: 'Utwórz',
  },
  move: {
    title: 'Przenieś do kolekcji',
    none: 'Bez kolekcji',
  },
  delete: {
    ask: 'Usunąć kolekcję „{name}”?',
    body: 'Paczki w niej zostaną.',
    submit: 'Usuń kolekcję',
  },
  merge: {
    heading: 'Scal paczki',
    explain: 'Paczki źródłowe znikną.',
    totalLabel: 'Razem klipów',
    nameLabel: 'Nazwa nowej paczki',
    defaultName: '{first} + {n}',
    confirm: 'Scal {count} paczek',
    confirm_one: 'Scal {count} paczkę',
    confirm_few: 'Scal {count} paczki',
    confirm_many: 'Scal {count} paczek',
  },
  dialog: {
    cancel: 'Anuluj',
  },
  toast: {
    deleted: 'Kolekcja usunięta.',
  },
  error: {
    nameTaken: 'Masz już kolekcję o tej nazwie.',
    title: 'Nie udało się zapisać kolekcji.',
    retry: 'Spróbuj ponownie',
  },
}
